import React from 'react';
import {
    List, Datagrid, TextField, BooleanField, EditButton, DeleteButton,
    Edit, Create, SimpleForm, TextInput, BooleanInput,
    SelectArrayInput, useGetList, usePermissions, required,
} from 'react-admin';

// Strip undefined so Firestore never rejects the payload
const sanitizeCollaboration = (values) => ({
    title: values.title ?? '',
    description: values.description ?? '',
    image: values.image ?? '',
    url: values.url ?? '',
    year: values.year ?? '',
    visibility: values.visibility ?? true,
    services: values.services ?? [],
});

export const CollaborationsList = (props) => {
    const { permissions } = usePermissions();
    return (
        <List {...props} title="Collaborations">
            <Datagrid rowClick="edit">
                <TextField source="title" label="Title" />
                <TextField source="year" label="Year" />
                <BooleanField source="visibility" label="Visible" />
                {permissions >= 98 && <EditButton />}
                {permissions >= 99 && <DeleteButton />}
            </Datagrid>
        </List>
    );
};

const CollaborationForm = () => {
    const { data: servicesData } = useGetList('services', {
        pagination: { page: 1, perPage: 100 },
        sort: { field: 'order', order: 'ASC' },
    });
    const serviceChoices = (servicesData ?? []).map(s => ({ id: s.id, name: s.name }));
    return (
        <>
            <TextInput source="title" label="Title" validate={required()} fullWidth />
            <TextInput source="description" label="Description" multiline rows={2} fullWidth defaultValue="" />
            <TextInput source="url" label="Website URL" fullWidth defaultValue="" placeholder="https://…" />
            <TextInput source="image" label="Image URL" fullWidth defaultValue="" placeholder="https://…" />
            <TextInput source="year" label="Year" defaultValue={String(new Date().getFullYear())} />
            <BooleanInput source="visibility" label="Visible on site" defaultValue={true} />
            <SelectArrayInput source="services" label="Services" choices={serviceChoices} />
        </>
    );
};

export const CollaborationsEdit = (props) => (
    <Edit {...props} title="Edit Collaboration" transform={sanitizeCollaboration}>
        <SimpleForm>
            <CollaborationForm />
        </SimpleForm>
    </Edit>
);

export const CollaborationsCreate = (props) => (
    <Create {...props} title="New Collaboration" transform={sanitizeCollaboration}>
        <SimpleForm>
            <CollaborationForm />
        </SimpleForm>
    </Create>
);
